import { apiEndpoint } from "./apiEndpoint";
import { types } from "../context/types";

export const Logout = async (dispatch) => {
  const token = sessionStorage.getItem("token");
  if (token) {
    await apiEndpoint.post(
      "/v1/user/logout/",
      {},
      {
        headers: {
          Authorization: "Bearer " + token,
        },
      }
    );
    sessionStorage.removeItem("data");
    sessionStorage.removeItem("token");
    sessionStorage.removeItem("user");
    dispatch({
      type: types["[Logout]"],
    });
  }
};
